import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

interface ColorPalette {
  primary: string;
  background: string;
}

export const COLOR_PALETTE: ColorPalette[] = [
  { primary: theme.colors.primary60, background: theme.colors.primary5 },
  { primary: theme.colors.critical60, background: theme.colors.critical5 },
  { primary: theme.colors.warning60, background: theme.colors.warning5 },
  { primary: theme.colors.success60, background: theme.colors.success5 },
  { primary: theme.colors.indigo60, background: theme.colors.indigo5 },
  { primary: theme.colors.rose60, background: theme.colors.rose5 },
  { primary: theme.colors.tangerine60, background: theme.colors.tangerine5 },
];

interface StyleOverrideProps {
  paletteIndex: number;
}

export function getThumbnailStyle({ paletteIndex }: StyleOverrideProps) {
  return css`
    width: ${theme.spacing(7)};
    padding: ${theme.spacing(1)};
    margin: ${theme.spacing(2)};
    border-radius: ${theme.spacing(2, 2, 0, 2)};
    background-color: ${COLOR_PALETTE[paletteIndex].background};
  `;
}

export function getIconStyle({ paletteIndex }: StyleOverrideProps) {
  return css`
    height: ${theme.spacing(3)};
    margin: ${theme.spacing(1)};
    color: ${COLOR_PALETTE[paletteIndex].primary};
  `;
}
